import React, { useState } from "react";
import {
  Box,
  Button,
  getColor,
  Icons,
  InputArea,
  InputField,
  Typography,
} from "fds";
import "./index.scss";
import { Workgroup } from "../../types/workgroup";
import WorkgroupDeleteModal from "./WorkgroupDeleteModal";
import { t } from "i18next";

interface WorkgroupInfoTabProps {
  workgroupInfo?: Workgroup;
  isWorkgroupManager?: boolean;
  changeWorkgroupInfo: (newWorkgroup: Workgroup) => void;
  onClose?: () => void;
}
const WorkgroupInfoTab: React.FC<WorkgroupInfoTabProps> = ({
  workgroupInfo,
  isWorkgroupManager,
  changeWorkgroupInfo,
  onClose,
}) => {
  /** State 정리 */
  const [isOpenWorkgroupDeleteModal, toggleOpenWorkgroupDeleteModal] =
    useState(false);

  /** 함수 정리 */
  /** UI: 워크그룹 상세정보 - 일반 사용자 화면 */
  const renderUserMode = () => {
    return (
      <Box direction="column">
        <Typography type="subtitle2">{t("common.basicInfo")}</Typography>
        <div className="workgroupModal-body--header" />
        <Box classes="mg mt-20 workgroupModal-body--items">
          <Box alignItems="center">
            <Typography
              type="subtitle2"
              exactColor={getColor("COLOR_TEXT_SECONDARY")}
              width={100}
            >
              {t("common.workgroupName")}
            </Typography>
            <Typography
              type="body2_rg"
              classes="mg ml-10"
              maxWidth={"calc(100% - 120px)"}
              wordBreak="break-word"
              exactColor={getColor("COLOR_TEXT_PRIMARY")}
            >
              {workgroupInfo?.workgroupName}
            </Typography>
          </Box>
          <Box alignItems="center">
            <Typography
              type="subtitle2"
              exactColor={getColor("COLOR_TEXT_SECONDARY")}
              width={100}
            >
              {t("common.desc")}
            </Typography>
            <Typography
              type="body2_rg"
              classes="mg ml-10"
              wordBreak="break-word"
              maxWidth={"calc(100% - 120px)"}
              exactColor={getColor("COLOR_TEXT_PRIMARY")}
            >
              {workgroupInfo?.desc}
            </Typography>
          </Box>
        </Box>
      </Box>
    );
  };
  /** UI: 워크그룹 상세정보 - 워크그룹장 화면 */
  const renderMasterMode = () => {
    return (
      <Box direction="column">
        {isOpenWorkgroupDeleteModal && (
          <WorkgroupDeleteModal
            open={isOpenWorkgroupDeleteModal}
            workgroupInfo={workgroupInfo}
            onClose={() => toggleOpenWorkgroupDeleteModal(false)}
            handleAfter={onClose}
          />
        )}
        <Typography type="subtitle2">{t("common.workgroupName")}</Typography>
        <InputField
          placeholder={t("workgroup.workgroupNamePlaceholder")}
          maxLength={120}
          size={"md"}
          value={workgroupInfo?.workgroupName}
          onChange={(e) =>
            workgroupInfo &&
            changeWorkgroupInfo({
              ...workgroupInfo,
              workgroupName: e.target.value,
            })
          }
          classes="mg mt-6"
        />
        <Typography classes="mg mt-32" type="subtitle2">
          {t("common.desc")}
        </Typography>
        <InputArea
          placeholder={t("workgroup.descPlaceholder")}
          maxLength={120}
          size={"md"}
          rows={3}
          value={workgroupInfo?.desc}
          onChange={(e) =>
            workgroupInfo &&
            changeWorkgroupInfo({
              ...workgroupInfo,
              desc: e.target.value,
            })
          }
          classes="mg mt-6"
        />
        {isWorkgroupManager && (
          <Button
            btnStyle="fill"
            size="lg"
            width="fit-content"
            type="error"
            label={t("workgroup.deleteWorkgroup")}
            leadingIcon={<Icons variant="line" label="delete" />}
            classes="mg mt-32"
            onClick={() => toggleOpenWorkgroupDeleteModal(true)}
          />
        )}
      </Box>
    );
  };
  return isWorkgroupManager ? renderMasterMode() : renderUserMode();
};
export default WorkgroupInfoTab;
